import React, { useState, useEffect } from "react";
import "datatables.net-dt/js/dataTables.dataTables";
import { Tabs, Tab } from "@appkit4/react-components/tabs";
import "../../../../../src/styles/userManagement.css";
import displayToastMessage from "../../../Common/Alert/displayToastMessage";
import {Modal} from "@appkit4/react-components/modal"
import ModalFooter from "@appkit4/react-components/esm/modal/ModalFooter";
import OnSiteAssessmentTable from './OnsiteAssessmentTable'
import OnSiteAssessmentInitiated from './OnsiteInitiatedAssessment'
import APIService from "../../../../services/apiAxiosService";
import useHttp from "../../../../hooks/useHttp";

export default function OnSiteAssessments(props) {
  const [currentTab, setCurrentTab] = useState("1");
  const [createTab, setCreateTab] = useState(true);
  const [deletemodalVisible, setDeletemodalVisible] = useState(false);
  const [visible, setVisible] = useState(false);
  const [onsiteData, setOnsiteData] = useState([])
  const [approvedData, setApprovedData] = useState([])
  const { sendRequest: getOnSiteAssessments } = useHttp();
  const { sendRequest: getInitiatedOnsiteAssessments } = useHttp();

  const getOnsiteAssessmentsforAssessor = async () => {
    getOnSiteAssessments(APIService.getOnSiteAssessments(), (res) => {
      if (res.CODE) {
        setOnsiteData(res.MSG)
      }
    })
  };

  const getInitiatedOnsiteAssessment = async () => {
    getInitiatedOnsiteAssessments(APIService.getInitiatedOnsiteAssessments(), (res) => {
      if (res.CODE) {
        setApprovedData(res.MSG)
      }
    })
  };

  const delete_click = () => {
    setVisible(false);
    setDeletemodalVisible(false);
    displayToastMessage("On Site Assessment deleted successfully", "success")
  }

  const handleTabs = (e, v) => {
    setCurrentTab(v);
    setCreateTab(true)
  };

  const handleCancel = e => {
    setVisible(false)
    setDeletemodalVisible(false)
  };

  useEffect(() => {
    getOnsiteAssessmentsforAssessor()
    getInitiatedOnsiteAssessment()
  }, []);

  return (
    <div className="App">
      <div className="user-management-container">
        <Tabs
          defaultValue={currentTab}
          value={currentTab}
          onChange={handleTabs}
          className="a-tab-item-padding-10"
        >
          <Tab value="1" label="Initiate On-site Assessment">
            <OnSiteAssessmentTable onsiteData={onsiteData} getOnsiteAssessmentsforAssessor={getOnsiteAssessmentsforAssessor} />
          </Tab>
          <Tab value="2" label="Conduct On-site Assessment">
            <OnSiteAssessmentInitiated InitiatedData={approvedData} />
          </Tab>
        </Tabs>
      </div>
      <Modal
        className="baseline-modal-showcase"
        visible={deletemodalVisible}
        onCancel={handleCancel}
        title="Are you sure you want to delete?"
        bodyStyle={{ maxHeight: "280px" }}
        footerStyle={{ paddingTop: "8px", marginTop: "-8px"}}
        modalStyle={{ width: "49.75rem" ,maxHeight:"fit-content" }}
      >
        <ModalFooter>
          <button
            type="button"
            className="cancel-button"
            onClick={handleCancel}
          >
            No
          </button>

          <button
            type="submit"
            className="save-button m-l-2"
            onClick={delete_click}
          >
            Yes
          </button>
        </ModalFooter>
      </Modal>
    </div>
  )
};
